import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {ApolloQueryObservable} from "apollo-angular";
import {SessionActions} from "../../../shared/actions/session.actions";
import {StickerSheet} from "../../../shared/view-model/store-management/sticker-sheet.type";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {MedicineStickersService} from "../../services/medicine-stickers.service";
import {FileService} from "../../../core/visbos-core/http/file.service";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-sticker-sheets-list',
  templateUrl: './sticker-sheets-list.component.html',
  styleUrls: ['./sticker-sheets-list.component.css']
})
export class StickerSheetsListComponent extends AbstractListView implements OnInit {

  @ViewChild('stickerSheetsTable')
  table: DatatableComponent;

  messages = {
    emptyMessage: 'Keine individuellen Druckbögen vorhanden',
    totalMessage: 'individuelle Druckbögen auf der Liste'
  };

  private sheetsList$: ApolloQueryObservable<any>;
  sheetsList: StickerSheet[];

  @Input()
  trainingMode: boolean = false;

  constructor(sessionActions: SessionActions,
              private medStickersService: MedicineStickersService,
              private fileService: FileService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.isLoading = true;

    this.sheetsList$ = this.medStickersService.getStickerSheets();
    this.addComponentData(this.sheetsList$);

    this.dataSubscriptions.push(
      this.sheetsList$.subscribe(res => {
        this.sheetsList = res.data.stickerSheets;
        this.isLoading = res.loading;
        this.rows = this.sheetsList;
      })
    );

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'label', name: 'Bezeichner', minWidth: 100, flexGrow: 2},
      {prop: 'created_at', name: 'Erstelldatum', cellTemplate: this.table.formatDateTmpl},
      {prop: 'administration_unit.label', name: 'Verwaltungseinheit', minWidth: 100, flexGrow: 2},
    ];

  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.sheetsList;
    } else {
      if (this.sheetsList) {
        this.rows = this.sheetsList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onGeneratePdfClicked(sheetCuid: string) {
    this.sessionActions.pushMessage('Druckbogen wird erzeugt, Sie werden benachrichtigt, sobald die PDF-Datei verfügbar ist. Dies kann einige Sekunden dauern.', MessageType.INFO, 'Spritzenetiketten');

    this.dataSubscriptions.push(this.medStickersService.createMedicineStickersPdf(null, [sheetCuid], null, null, this.trainingMode).subscribe(
      res => {
        this.sessionActions.pushMessage('Der Druckbogen wurde erfolgreich generiert!', MessageType.SUCCESS, 'Spritzenetiketten');
        let base64Data = res.data.generateMedicineStickersPDF;
        let blob = this.fileService.base64toBlob(base64Data, 'application/pdf', 512);
        this.fileService.saveAs(blob, 'druckbogen-spritzenetiketten.pdf');
      },
      err => {
        this.sessionActions.throwError(err, 'Fehler bei der Erstellung des Druckbogens, bitte wenden Sie sich an den Support!');
      }));

  }

  onDeletePrintedSheetClicked(printedSheetCuid: string) {
    this.medStickersService.deleteCustomStickersSheet(printedSheetCuid).toPromise()
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Löschen des Druckbogens!"));
  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/components/sticker-sheets-list/sticker-sheets-list.component.ts